import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';

const checkVideoExistense = (url) => new Promise((resolve, reject) => {
  let http = new XMLHttpRequest()
  http.open('HEAD', url, false)
  try {
    http.send()
    resolve(http.status !== 404)
  } catch (e) {
    resolve(false)
  }
})

export const wrapVideoDownloadInfo = (mode, data, title, camindex=0) => {
  const pid = mode === 'balls'? `${data.plate_id}_${data.Pitch_ID}`:`${data.plate_id}`
  const inn = data.Inning+"局"+(data["Top/Bottom"]==="Top"? "上":"下")
  const result = data.PA_Result ? data.PA_Result : data.PitchCode
  const id = mode === 'balls' ? `[${data.plate_id}${data.Pitch_ID}]` : `[${data.plate_id}]`
  if (mode === 'balls') return { id: pid, cam: camindex, name: `${id}_${title}_${data.Date}_G${data.GameNo}_${inn}_${data.Pitcher}_${data.Batter}_${data.TaggedPitchType}_${result}` }
  else return {id: pid, name: `${id}_${data.Date}_G${data.GameNo}_${inn}_${data.Pitcher}_${data.Batter}_${result}`}
}

export const wrapURL = (mode, v, cams) => {
  if (mode === 'balls') {
    if (v.cam === 0) return `https://stats-inisght.synology.me/gamevideo/${mode}/${v.id}.mp4`
    else return `https://stats-inisght.synology.me/stadium/${cams[v.cam]}/${v.id}.mp4`
  } else {
    return `https://stats-inisght.synology.me/gamevideo/${mode}/${v.id}.mp4`
  }
}

 export const downloadVideos = (mode, videos, cams, setModalMsg, setModalVis) => {
    const zip = new JSZip();
    let count = 0;
    let date = new Date()
    let someFileNotExist = false
    const zipFilename = `${date.toISOString()}.zip`;
    videos.forEach(async (v) => {
      const filename = `${v.name}.mp4`;
      const url = wrapURL(mode, v, cams)
      const fileExist = await checkVideoExistense(url)
      someFileNotExist = someFileNotExist || (!fileExist)
      if (fileExist) {
        try {
          const file = await JSZipUtils.getBinaryContent(url)
          zip.file(filename, file, { binary: true});
        } catch (err) {
          console.log(err);
        }
      }
      count++
      if(count === videos.length) {
        zip.generateAsync({type:'blob'}).then(function(content) {
          saveAs(content, zipFilename);
        });
      }
      if (someFileNotExist) {
        setModalMsg({type: 'warning', msg: '部分下載影片缺失，僅下載可供存取之影片'})
        setModalVis(true)
      }
    });
}